<template>
    <div>
        <transition name="wa-modal-fade">
            <div v-if="visible" class="wa-modal-overlay" @click="handleOverlayClick">
                <div class="wa-modal-container" @click.stop>
                    <button class="wa-modal-close" @click="handleCancel">
                        <span class="material-icons">close</span>
                    </button>

                    <div class="wa-modal-wrapper">
                    <div class="wa-modal-header">
                        <h2>WhatsApp Entegrasyonu</h2>
                        <p>İşletmenize en uygun WhatsApp çözümünü seçin</p>
                    </div>

                    <div class="wa-modal-body">
                        <div class="wa-solutions-grid">
                            <!-- V2 Card -->
                            <div class="wa-solution-card wa-v2-card">
                                <div class="wa-card-icon">
                                    <div class="wa-icon-circle whatsapp-bg">
                                        <WhatsappV2Icon color="#fff" />
                                    </div>
                                </div>
                                <div class="wa-card-content">
                                    <h3>WhatsApp V2</h3>
                                    <p class="wa-card-subtitle">QR Kod ile Hızlı Başlangıç</p>

                                    <div class="wa-features-section">
                                        <div class="wa-pros">
                                            <h4><span class="icon-check">✓</span> Avantajlar</h4>
                                            <ul>
                                                <li>Dakikalar içinde kurulum</li>
                                                <li>Ekstra belge gerektirmez</li>
                                                <li>Temel mesajlaşma özellikleri</li>
                                                <li>Grup desteği</li>
                                            </ul>
                                        </div>

                                        <div class="wa-cons">
                                            <h4><span class="icon-cross">✕</span> Sınırlamalar</h4>
                                            <ul>
                                                <li>Cihaz bağımlı</li>
                                                <li>Düşük SLA</li>
                                                <li>Ban riski var</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- V3 Card -->
                            <div class="wa-solution-card wa-v3-card">
                                <div class="wa-card-icon">
                                    <div class="wa-icon-circle whatsapp-bg">
                                        <WhatsappV3Icon color="#fff" />
                                    </div>
                                </div>
                                <div class="wa-card-content">
                                    <h3>WhatsApp V3</h3>
                                    <p class="wa-card-subtitle">Gelişmiş Özellikler</p>

                                    <div class="wa-features-section">
                                        <div class="wa-pros">
                                            <h4><span class="icon-check">✓</span> Avantajlar</h4>
                                            <ul>
                                                <li>V2'nin tüm özellikleri</li>
                                                <li>Mesaj alıntılama</li>
                                                <li>Newsletter kanalları</li>
                                                <li>Profil fotoğrafı alma</li>
                                            </ul>
                                        </div>

                                        <div class="wa-cons">
                                            <h4><span class="icon-cross">✕</span> Sınırlamalar</h4>
                                            <ul>
                                                <li>Cihaz bazlı</li>
                                                <li>Ban riski devam eder</li>
                                                <li>Düşük SLA</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- API Card -->
                            <div class="wa-solution-card wa-api-card">
                                <div class="wa-card-icon">
                                    <div class="wa-icon-circle whatsapp-bg">
                                        <WhatsappBusinessIcon color="#fff" />
                                    </div>
                                </div>
                                <div class="wa-card-content">
                                    <h3>WhatsApp API</h3>
                                    <p class="wa-card-subtitle">Kurumsal Çözüm</p>

                                    <div class="wa-features-section">
                                        <div class="wa-pros">
                                            <h4><span class="icon-check">✓</span> Avantajlar</h4>
                                            <ul>
                                                <li>Meta onaylı resmi çözüm</li>
                                                <li>%99.9 SLA garantisi</li>
                                                <li>REST API desteği</li>
                                                <li>Şablon mesajlar</li>
                                            </ul>
                                        </div>

                                        <div class="wa-cons">
                                            <h4><span class="icon-cross">✕</span> Sınırlamalar</h4>
                                            <ul>
                                                <li>Uzun kurulum süreci</li>
                                                <li>Mesaj ücreti var</li>
                                                <li>Belge gerekli</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="wa-info-banner">
                            <span class="material-icons">info</span>
                            <p>
                                <strong>Bağlantı Stabilitesi:</strong> V2 ve V3 çözümleri nadiren bağlantı kesintisi yaşayabilir.
                                Kritik operasyonlar için WABA API önerilir.
                            </p>
                        </div>
                    </div>

                    <div class="wa-modal-footer">
                        <button class="wa-btn wa-btn-link" @click="handleDetailedComparison">
                            <span class="material-icons">compare_arrows</span>
                            Detaylı Karşılaştırma
                        </button>
                        <div class="wa-footer-actions">
                            <button class="wa-btn wa-btn-secondary" @click="handleCancel">
                                İptal
                            </button>
                            <button class="wa-btn wa-btn-primary" @click="handleAccept">
                                Onayla ve devam et
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </transition>

        <!-- Detaylı Karşılaştırma Modal'ı -->
        <transition name="wa-modal-fade">
            <div v-if="showDetailedModal" class="wa-detailed-modal-overlay" @click="closeDetailedModal">
                <div class="wa-detailed-modal-container" @click.stop>
                    <button class="wa-modal-close" @click="closeDetailedModal">
                        <span class="material-icons">close</span>
                    </button>
                    <WhatsappComparison />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import WhatsappV2Icon from "../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import WhatsappV3Icon from "../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV3.vue";
import WhatsappBusinessIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import WhatsappComparison from "./WhatsappComparison.vue";

export default {
    name: "WhatsappSolutionComparisonModal",
    components: {
        WhatsappV2Icon,
        WhatsappV3Icon,
        WhatsappBusinessIcon,
        WhatsappComparison,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showDetailedModal: false,
        };
    },
    methods: {
        handleCancel() {
            this.$emit("cancel");
        },
        handleAccept() {
            this.$emit("accept");
        },
        handleOverlayClick() {
            this.handleCancel();
        },
        handleDetailedComparison() {
            this.showDetailedModal = true;
        },
        closeDetailedModal() {
            this.showDetailedModal = false;
        },
    },
};
</script>

<style lang="scss">
// WhatsApp Solution Comparison Modal - Custom Modal Styles
.wa-modal-fade-enter-active,
.wa-modal-fade-leave-active {
    transition: opacity 0.3s ease;
}

.wa-modal-fade-enter,
.wa-modal-fade-leave-to {
    opacity: 0;
}

.wa-modal-fade-enter-active .wa-modal-container,
.wa-modal-fade-leave-active .wa-modal-container {
    transition: transform 0.3s ease;
}

.wa-modal-fade-enter .wa-modal-container,
.wa-modal-fade-leave-to .wa-modal-container {
    transform: scale(0.95);
}

.wa-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 15px;
    overflow-y: auto;
}

.wa-modal-container {
    position: relative;
    width: 100%;
    max-width: 1100px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    margin: auto;

    @media (max-height: 800px) {
        max-width: 1000px;
    }

    @media (max-height: 700px) {
        max-width: 950px;
        border-radius: 8px;
    }
}

.wa-modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 36px;
    height: 36px;
    border: none;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    .material-icons {
        color: #6b7280;
        font-size: 20px;
    }

    &:hover {
        background: #ffffff;
        transform: rotate(90deg);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

        .material-icons {
            color: #1f2937;
        }
    }
}

.wa-modal-wrapper {
    display: flex;
    flex-direction: column;

    .wa-modal-header {
        padding: 24px 30px;
        background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
        text-align: center;

        h2 {
            margin: 0 0 6px 0;
            font-size: 22px;
            font-weight: 800;
            color: #ffffff;
            letter-spacing: -0.5px;

            @media (max-height: 700px) {
                font-size: 20px;
                margin-bottom: 4px;
            }
        }

        p {
            margin: 0;
            font-size: 13px;
            color: rgba(255, 255, 255, 0.9);
            font-weight: 500;

            @media (max-height: 700px) {
                font-size: 12px;
            }
        }
    }

    .wa-modal-body {
        padding: 24px 30px;
        background: #f8f9fa;

        @media (max-height: 800px) {
            padding: 20px 25px;
        }

        @media (max-height: 700px) {
            padding: 18px 20px;
        }
    }

    .wa-solutions-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 18px;
        margin-bottom: 20px;

        @media (max-height: 800px) {
            gap: 16px;
            margin-bottom: 18px;
        }

        @media (max-height: 700px) {
            gap: 14px;
            margin-bottom: 16px;
        }

        @media (max-width: 1024px) {
            grid-template-columns: 1fr;
        }
    }

    .wa-solution-card {
        background: #ffffff;
        border-radius: 12px;
        overflow: hidden;
        border: 2px solid #e5e7eb;
        transition: all 0.3s ease;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

        @media (max-height: 700px) {
            border-radius: 10px;
        }

        &:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
        }

        .wa-card-icon {
            padding: 20px 20px 16px;
            text-align: center;
            background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);

            @media (max-height: 800px) {
                padding: 18px 18px 14px;
            }

            @media (max-height: 700px) {
                padding: 16px 16px 12px;
            }

            .wa-icon-circle {
                width: 64px;
                height: 64px;
                margin: 0 auto;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 8px 20px rgba(37, 211, 102, 0.25);

                @media (max-height: 800px) {
                    width: 56px;
                    height: 56px;
                    border-radius: 10px;
                }

                @media (max-height: 700px) {
                    width: 50px;
                    height: 50px;
                    border-radius: 8px;
                }

                &.whatsapp-bg {
                    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
                }

                svg {
                    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
                    width: 40px !important;
                    height: 40px !important;

                    @media (max-height: 800px) {
                        width: 36px !important;
                        height: 36px !important;
                    }

                    @media (max-height: 700px) {
                        width: 32px !important;
                        height: 32px !important;
                    }
                }
            }
        }

        .wa-card-content {
            padding: 0 20px 24px;

            @media (max-height: 800px) {
                padding: 0 18px 20px;
            }

            @media (max-height: 700px) {
                padding: 0 16px 18px;
            }

            h3 {
                margin: 0 0 3px 0;
                font-size: 17px;
                font-weight: 800;
                color: #1f2937;
                text-align: center;

                @media (max-height: 800px) {
                    font-size: 16px;
                }

                @media (max-height: 700px) {
                    font-size: 15px;
                    margin-bottom: 2px;
                }
            }

            .wa-card-subtitle {
                margin: 0 0 16px 0;
                font-size: 11px;
                color: #6b7280;
                font-weight: 600;
                text-align: center;

                @media (max-height: 800px) {
                    margin-bottom: 14px;
                    font-size: 10px;
                }

                @media (max-height: 700px) {
                    margin-bottom: 12px;
                    font-size: 10px;
                }
            }

            .wa-features-section {
                .wa-pros,
                .wa-cons {
                    margin-bottom: 14px;

                    @media (max-height: 800px) {
                        margin-bottom: 12px;
                    }

                    @media (max-height: 700px) {
                        margin-bottom: 10px;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }

                    h4 {
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        margin: 0 0 8px 0;
                        font-size: 11px;
                        font-weight: 800;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;

                        @media (max-height: 800px) {
                            font-size: 10px;
                            margin-bottom: 7px;
                            gap: 5px;
                        }

                        @media (max-height: 700px) {
                            font-size: 9px;
                            margin-bottom: 6px;
                            gap: 4px;
                        }

                        .icon-check {
                            color: #10b981;
                            font-size: 14px;

                            @media (max-height: 700px) {
                                font-size: 12px;
                            }
                        }

                        .icon-cross {
                            color: #ef4444;
                            font-size: 14px;

                            @media (max-height: 700px) {
                                font-size: 12px;
                            }
                        }
                    }

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;

                        li {
                            padding: 6px 10px;
                            margin-bottom: 5px;
                            background: #f9fafb;
                            border-radius: 6px;
                            font-size: 11px;
                            color: #4b5563;
                            font-weight: 500;
                            transition: all 0.2s ease;

                            @media (max-height: 800px) {
                                padding: 5px 9px;
                                margin-bottom: 4px;
                                font-size: 10px;
                            }

                            @media (max-height: 700px) {
                                padding: 4px 8px;
                                margin-bottom: 3px;
                                font-size: 9px;
                                border-radius: 5px;
                            }

                            &:hover {
                                background: #f3f4f6;
                                transform: translateX(2px);
                            }

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                .wa-pros {
                    h4 {
                        color: #10b981;
                    }
                }

                .wa-cons {
                    h4 {
                        color: #ef4444;
                    }
                }
            }
        }

        &.wa-v2-card {
            &:hover {
                border-color: #f59e0b;
            }
        }

        &.wa-v3-card {
            &:hover {
                border-color: #3b82f6;
            }
        }

        &.wa-api-card {
            &:hover {
                border-color: #10b981;
            }
        }
    }

    .wa-info-banner {
        display: flex;
        align-items: center;
        gap: 12px;
        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
        border: 2px solid #fbbf24;
        border-radius: 10px;
        padding: 14px 16px;

        @media (max-height: 800px) {
            padding: 12px 14px;
            gap: 10px;
        }

        @media (max-height: 700px) {
            padding: 10px 12px;
            gap: 8px;
            border-radius: 8px;
        }

        .material-icons {
            color: #d97706;
            font-size: 20px;
            flex-shrink: 0;

            @media (max-height: 700px) {
                font-size: 18px;
            }
        }

        p {
            margin: 0;
            font-size: 11px;
            color: #78350f;
            line-height: 1.5;

            @media (max-height: 800px) {
                font-size: 10px;
            }

            @media (max-height: 700px) {
                font-size: 9px;
            }

            strong {
                font-weight: 800;
                color: #92400e;
            }
        }
    }

        .wa-modal-footer {
        padding: 16px 30px 20px;
        background: #ffffff;
        border-top: 1px solid #e5e7eb;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;

        @media (max-height: 800px) {
            padding: 14px 25px 18px;
        }

        @media (max-height: 700px) {
            padding: 12px 20px 16px;
            gap: 8px;
        }

        .wa-footer-actions {
            display: flex;
            gap: 10px;

            @media (max-height: 700px) {
                gap: 8px;
            }
        }

        .wa-btn {
            height: 36px;
            padding: 0 20px;
            border-radius: 8px;
            font-weight: 700;
            font-size: 13px;
            border: none;
            cursor: pointer;
            transition: all 0.3s ease;
            outline: none;
            display: flex;
            align-items: center;
            gap: 6px;

            @media (max-height: 800px) {
                height: 34px;
                padding: 0 18px;
                font-size: 12px;
            }

            @media (max-height: 700px) {
                height: 32px;
                padding: 0 16px;
                font-size: 11px;
                border-radius: 6px;
            }

            &:active {
                transform: scale(0.98);
            }

            .material-icons {
                font-size: 18px;

                @media (max-height: 700px) {
                    font-size: 16px;
                }
            }

            &.wa-btn-link {
                background: transparent;
                color: #4a6cf7;
                padding: 0 12px;

                &:hover {
                    background: #f3f4f6;
                    color: #3b5bdb;
                }
            }

            &.wa-btn-primary {
                background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
                color: #ffffff;
                box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);

                &:hover {
                    background: linear-gradient(135deg, #128C7E 0%, #075e54 100%);
                    box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);
                    transform: translateY(-2px);
                }
            }

            &.wa-btn-secondary {
                background: #ffffff;
                border: 1.5px solid #d1d5db;
                color: #6b7280;

                &:hover {
                    border-color: #25D366;
                    color: #128C7E;
                }
            }
        }
    }
}

// Detaylı Karşılaştırma Modal Stilleri
.wa-detailed-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;
    padding: 20px;
    overflow-y: auto;
}

.wa-detailed-modal-container {
    position: relative;
    width: 100%;
    max-width: 1400px;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    margin: auto;
    max-height: 95vh;
    overflow-y: auto;
}
</style>

